import { globalStyObj } from '@/assets/packageAssets/allStyleConfigs/a-global-cfg.js'

import { echoStyObj } from '@/assets/packageAssets/allStyleConfigs/echo.cfg.js'
import { joychatStyObj } from '@/assets/packageAssets/allStyleConfigs/joychat.cfg.js'
import { kikoStyObj } from '@/assets/packageAssets/allStyleConfigs/kiko.cfg.js'
import { vavaStyObj } from '@/assets/packageAssets/allStyleConfigs/vava.cfg.js'
import { vibeoStyObj } from '@/assets/packageAssets/allStyleConfigs/vibeo.cfg.js'

// 包变量
const styObj = {
  echo: {
    // 样式资源
    ...echoStyObj,
    // 图片资源
    '--icon-arrow': `url(${require('@/assets/packageAssets/views/P1_Boys/PayNext/vava/arrow.png')})`,
    '--icon-check': `url(${require('@/assets/packageAssets/views/P1_Boys/PayNext/vava/check.png')})`,
    '--icon-not-check': `url(${require('@/assets/packageAssets/views/P1_Boys/PayNext/vava/not-check.png')})`,
    '--icon-tag-bg': `url(${require('@/assets/packageAssets/views/P1_Boys/PayNext/vava/tag-bg.png')})`,
    '--icon-trangle': `url(${require('@/assets/packageAssets/views/P1_Boys/PayNext/vava/trangle.png')})`
  },
  joychat: {// 样式资源
    ...joychatStyObj,
    // 图片资源
    '--icon-arrow': `url(${require('@/assets/packageAssets/views/P1_Boys/PayNext/vava/arrow.png')})`,
    '--icon-check': `url(${require('@/assets/packageAssets/views/P1_Boys/PayNext/vava/check.png')})`,
    '--icon-not-check': `url(${require('@/assets/packageAssets/views/P1_Boys/PayNext/vava/not-check.png')})`,
    '--icon-tag-bg': `url(${require('@/assets/packageAssets/views/P1_Boys/PayNext/vava/tag-bg.png')})`,
    '--icon-trangle': `url(${require('@/assets/packageAssets/views/P1_Boys/PayNext/vava/trangle.png')})`
  },
  kiko: {// 样式资源
    ...kikoStyObj,
    // 图片资源
    '--icon-arrow': `url(${require('@/assets/packageAssets/views/P1_Boys/PayNext/vava/arrow.png')})`,
    '--icon-check': `url(${require('@/assets/packageAssets/views/P1_Boys/PayNext/vava/check.png')})`,
    '--icon-not-check': `url(${require('@/assets/packageAssets/views/P1_Boys/PayNext/vava/not-check.png')})`,
    '--icon-tag-bg': `url(${require('@/assets/packageAssets/views/P1_Boys/PayNext/vava/tag-bg.png')})`,
    '--icon-trangle': `url(${require('@/assets/packageAssets/views/P1_Boys/PayNext/vava/trangle.png')})`
  },
  vava: {// 样式资源
    ...vavaStyObj,
    // 图片资源
    '--icon-arrow': `url(${require('@/assets/packageAssets/views/P1_Boys/PayNext/vava/arrow.png')})`,
    '--icon-check': `url(${require('@/assets/packageAssets/views/P1_Boys/PayNext/vava/check.png')})`,
    '--icon-not-check': `url(${require('@/assets/packageAssets/views/P1_Boys/PayNext/vava/not-check.png')})`,
    '--icon-tag-bg': `url(${require('@/assets/packageAssets/views/P1_Boys/PayNext/vava/tag-bg.png')})`,
    '--icon-trangle': `url(${require('@/assets/packageAssets/views/P1_Boys/PayNext/vava/trangle.png')})`
  },
  vibeo: {// 样式资源
    ...vibeoStyObj,
    // 图片资源
    '--icon-arrow': `url(${require('@/assets/packageAssets/views/P1_Boys/PayNext/vava/arrow.png')})`,
    '--icon-check': `url(${require('@/assets/packageAssets/views/P1_Boys/PayNext/vava/check.png')})`,
    '--icon-not-check': `url(${require('@/assets/packageAssets/views/P1_Boys/PayNext/vava/not-check.png')})`,
    '--icon-tag-bg': `url(${require('@/assets/packageAssets/views/P1_Boys/PayNext/vava/tag-bg.png')})`,
    '--icon-trangle': `url(${require('@/assets/packageAssets/views/P1_Boys/PayNext/vava/trangle.png')})`
  },
}

export const pageCssVars = {
  methods: {
    cssVars () {
      if (this.packageName && styObj[this.packageName]) {
        // 全局 + 局部包
        return { ...globalStyObj, ...styObj[this.packageName] }
      }
      return {}
    }
  }
}
